/**
 * For usage and examples, check `routeTypes.ts`.
 */
import { createBrowserHistory } from "history"

import { AccountRoutes } from "src/router/accountRoutes"
import { AiAssistantRoutes } from "src/router/aiAssistantRoutes"
import { CallAssistRoutes } from "src/router/callAssistRoutes"
import { GuestAccessRoutes } from "src/router/guestAccessRoutes"
import { HomeGroupRoutes } from "src/router/homeGroupRoutes"
import { HomeRoutes } from "src/router/homeRoutes"
import { InboxRoutes } from "src/router/inboxRoutes"
import { OrganizationRoutes } from "src/router/organizationRoutes"
import { ParadiseRoutes } from "src/router/ParadiseRoutes"
import { ReportRoutes } from "src/router/reportRoutes"
import { ResponseServiceRoutes } from "src/router/responseServiceRoutes"
import { createBasicLocation } from "src/router/routeTypes"
import { SensorRoutes } from "src/router/sensorRoutes"
import { SettingsRoutes } from "src/router/settingsRoutes"
import { SignupLoginRoutes } from "src/router/signupLoginRoutes"
import { TaskManagementRoutes } from "src/router/taskManagementRoutes"

const Dashboard = createBasicLocation("/dashboard")
const Onboarding = createBasicLocation("/onboarding")
const OnboardingCreateOrganization = createBasicLocation(
  "/onboarding/create-organization"
)
const OnboardingJoinOrganization = createBasicLocation(
  "/onboarding/join-organization"
)

const ReferralProgram = createBasicLocation("/refer-a-friend")

export const Routes = {
  Dashboard,
  Onboarding,
  OnboardingCreateOrganization,
  OnboardingJoinOrganization,
  ReferralProgram,
  ...HomeRoutes,
  ...OrganizationRoutes,
  ...HomeGroupRoutes,
  ...ResponseServiceRoutes,
  ...AccountRoutes,
  ...SensorRoutes,
  ...SignupLoginRoutes,
  ...GuestAccessRoutes,
  ...SettingsRoutes,
  ...CallAssistRoutes,
  ...ParadiseRoutes,
  ...ReportRoutes,
  ...TaskManagementRoutes,
  ...InboxRoutes,
  ...AiAssistantRoutes,
} as const

export const browserHistory = createBrowserHistory()
